import styled from 'styled-components';

interface RuleBuilderDragItemProps {
  isDragging: boolean;
}

const RuleBuilderDragItem = styled.div<RuleBuilderDragItemProps>`
  position: relative;
  margin-bottom: ${(props): string => props.theme.spaces.lg};

  .ruleBuilderItem {
    padding-left: ${(props): string => props.theme.spaces.md};
    outline: solid 1px
      ${(props): string =>
        props.isDragging ? props.theme.colors.lqBlue : 'transparent'};
  }
  .dragIcon {
    position: absolute;
    top: 1.7rem;
    left: 0.5rem;
    display: ${(props): string => (props.isDragging ? 'block' : 'none')};
  }

  &:hover {
    cursor: move;
    .dragIcon {
      display: block;
    }
  }
`;

export { RuleBuilderDragItem };
